var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNorwayLotto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    width: 40,
    height: 40,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      paintOrder: "fill",
      fill: "#d41040"
    },
    "data-bx-origin": "0.4932 0.4955",
    d: "M0 0h100v100H0z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(7 39.977)",
    "data-bx-origin": "0.509033 0.001155"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M58.727 3.278h-8.218a1.686 1.686 0 1 0 0 3.371h2.444v8.345a1.77 1.77 0 1 0 3.54 0V6.649h2.234a1.686 1.686 0 1 0 0-3.371ZM33.524 13.392h-4.888V5.048a1.77 1.77 0 0 0-3.54 0v9.946c0 .977.792 1.77 1.77 1.77h6.658a1.686 1.686 0 0 0 0-3.372Zm8.598 0a3.375 3.375 0 0 1-3.372-3.371 3.375 3.375 0 0 1 3.372-3.372 3.375 3.375 0 0 1 3.371 3.372 3.375 3.375 0 0 1-3.371 3.372Zm0-10.283a6.912 6.912 0 1 0 0 13.824 6.912 6.912 0 0 0 0-13.824Zm37.425 10.284a3.375 3.375 0 0 1-3.371-3.372 3.375 3.375 0 0 1 3.371-3.372 3.375 3.375 0 0 1 3.372 3.372 3.375 3.375 0 0 1-3.372 3.372Zm0-10.284a6.912 6.912 0 1 0 0 13.824 6.912 6.912 0 0 0 0-13.824Zm-8.387.169h-8.22a1.686 1.686 0 1 0 0 3.371h2.234v8.345a1.77 1.77 0 1 0 3.54 0V6.649h2.445a1.686 1.686 0 1 0 0-3.371Z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20.068v20H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    d: "m15.066 10.927-4.102 4.088 9.104.897-5.002-4.985ZM15.966 0l-5.002 4.985 4.102 4.088.9-9.073ZM4.102 20l1.831-10L0 15.912 4.102 20ZM0 4.088 5.933 10h8.203L0 4.088Z",
    mask: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FEFEFE",
    fillOpacity: 0.65,
    d: "m15.966 20 4.102-4.088-9.104-.897L15.966 20Zm0-20-.9 9.073 5.002-4.985L15.966 0ZM4.102 20l10.034-10H5.933L4.102 20ZM0 4.088 14.136 10 4.102 0 0 4.088Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNorwayLotto);
export default __webpack_public_path__ + "static/media/norway_lotto.ce351e7e358efbf7bfc6ab082b09ef96.svg";
export { ForwardRef as ReactComponent };